"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M12 0a6.465 6.465 0 0 1 6.454 6.226l.004.231v3.835h.272c1.11 0 2.02.863 2.098 1.953l.005.15v9.501c0 1.11-.863 2.021-1.953 2.099l-.15.005H5.271a2.106 2.106 0 0 1-2.099-1.954l-.005-.15v-9.501c0-1.11.863-2.02 1.954-2.098l.15-.005h.272V6.457A6.464 6.464 0 0 1 12 0Zm6.73 11.332H5.271c-.548 0-1 .415-1.059.947l-.006.116v9.501c0 .548.416 1 .95 1.058l.115.006H18.73c.547 0 1-.416 1.058-.948l.006-.116v-9.501c0-.547-.416-.999-.948-1.057l-.116-.006Zm-6.731 2.444a1.94 1.94 0 0 1 1.37.552c.366.364.567.85.567 1.369 0 .518-.201 1.005-.568 1.37-.195.195-.43.347-.69.443l-.158.05v2.38a.52.52 0 0 1-1.03.094l-.01-.093v-2.38a1.91 1.91 0 0 1-.85-.495 1.916 1.916 0 0 1-.566-1.37c0-.518.2-1.005.567-1.37.349-.349.848-.55 1.368-.55Zm0 1.024a.896.896 0 0 0-.634 1.531c.296.296.846.32 1.183.075l.087-.073a.9.9 0 0 0 0-1.271A.892.892 0 0 0 12 14.8ZM12 1.039a5.424 5.424 0 0 0-5.414 5.2l-.004.218v3.835h10.837V6.457A5.424 5.424 0 0 0 12 1.039Z",
    clipRule: "evenodd"
  })]
});